<template>
  <div>
    <Button
      v-if="showLateArrivals"
      :size="17"
      :width="35"
      color="#BB8D1C"
      colorText="#ffffff"
      icon="fas fa-box-open"
      tooltip="Ver late arrivals"
      class="mt-2 mb-2 mr-2"
      round
      traslate
      @click.native="openModal('modal');"
    />

    <ui-modal
      ref="modal"
      title="Ver Late Arrivals"
      class="modal-late-arrivals"
      @close="cerrarModal,ActionSetZindexModal(false)"
    >
      <late-arrivals-page />
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapActions } from "vuex";

// Keen UI
import UiModal from "keen-ui/lib/UiModal";

// Componentes
import LateArrivalsPage from "../../../../views/lineas/booking/BookingsLateArrivalsModalPage";
import Button from "../../../common/Button";

export default {
  data() {
      return {
        showLateArrivals: false,
      };
    },
  components: {
    LateArrivalsPage,
    UiModal,
    Button,
  },
  methods: {
    ...mapActions(["ActionSetZindexModal","ActionSetZindexTablaModal"]),


    openModal(ref) {
      //this.ActionSetZindexModal(false);
      this.ActionSetZindexTablaModal(false);

      this.ActionSetZindexModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    cerrarModal() {
      this.ActionSetZindexModal(false);
    },
  },
  /**
  * @author Miguel González.
  * @description funcion que valida si el rol logeado puede visualizar este componente
  * last modified 18-04-2023 17:23 */
  created(){
      const lineasStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 1);
      if(JSON.parse(localStorage.getItem('user')).rol === 'Super Administrador'){
        this.showLateArrivals = true;
      }
      if(lineasStructure){
        lineasStructure.sections.map(({ idSection, subSections }) => {
          switch (idSection) {
            case 22: //bookings
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 66: this.showLateArrivals = true; break;
                  default: break;
                }
              });
              break;
            default: break;
          }
        })
      }
    }
};
</script>

<style>
.modal-late-arrivals .ui-modal__container {
  width: 85% !important;
}
</style>
